import Swiper from 'swiper'

const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

if(homeSlideshow){
    let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
    let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    let config = {
        effect : 'fade',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        fadeEffect: {
            crossFade: true
        },

        slidesPerView: 1,
        spaceBetween: 0,  

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        // Navigation (arrow)
        navigation: {
            nextEl: `.swiper-button-next`,
            prevEl: `.swiper-button-prev`,
        },

        // Pagination (bullet)
        pagination: {
            el: '.slideshow__pagination',
            type: 'bullets',
            clickable: true
        }
    }

    if(dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if(nbSlides > 1) {
        let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
    }
}

// Slider Events
let eventsSlides = document.querySelectorAll('.home-events .swiper-container .swiper-slide').length;

let eventsConfig = {
    effect : 'slide',
    grabCursor : 'true',
    speed: 700,
    slidesPerView: 'auto',

    fadeEffect: {
        crossFade: true
    },

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

    breakpoints: {
        1201: {
            slidesPerView: 3,
            spaceBetween: 30,  
        },

        961: {
            slidesPerView: 3,
            spaceBetween: 20, 
        },
        
        641: {
            slidesPerView: 2,
            spaceBetween: 20
        },

        0: {
            slidesPerView: 1,
            spaceBetween: 20
        }
    },  

    navigation: {
        nextEl: `.home-events__navigation .swiper-button-next`,
        prevEl: `.home-events__navigation .swiper-button-prev`,
    },
}

if(eventsSlides > 1) {
    let swiperEvents = new Swiper('.home-events .swiper-container', eventsConfig);
}

// slider Actualités
const newsSlideshow = document.querySelector('.home .news .swiper-container') !== null;
        
if (newsSlideshow) {
    let newsSlides = document.querySelectorAll('.home .news .swiper-container .swiper-slide').length;

    let newsConfig = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        slidesPerView: 'auto',

    fadeEffect: {
        crossFade: true
    },

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

        navigation: {
            nextEl: `.news .swiper-button-next`,
            prevEl: `.news .swiper-button-prev`,
        },

        breakpoints: {
            1201: {
                slidesPerView: 3,
                spaceBetween: 30,  
            },
    
            961: {
                slidesPerView: 3,
                spaceBetween: 20, 
            },
            
            641: {
                slidesPerView: 2,
                spaceBetween: 20
            },
    
            0: {
                slidesPerView: 1,
                spaceBetween: 20
            }
        }
    }

    if(newsSlides > 1) {
        let swiperNews = new Swiper('.home .news .swiper-container', newsConfig);
    }
}


